export const Vignette = (size: number, strength: number) => (srcData: any) => {
  const vignetteSize = Math.max(0.1, Math.min(1, size / 100)); // 0.1 to 1
  const vignetteStrength = Math.max(-1, Math.min(1, strength / 100)); // -1 to 1

  if (vignetteStrength === 0) return srcData;

  const data = srcData.data;
  const width = srcData.width;
  const height = srcData.height;

  // Determine vignette direction based on strength
  const isWhite = vignetteStrength < 0;
  const absStrength = Math.abs(vignetteStrength);

  // Center of the image
  const centerX = width / 2;
  const centerY = height / 2;

  // Maximum distance from center to any corner (for normalization)
  const maxDistance = Math.sqrt(centerX * centerX + centerY * centerY);

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const pixelIndex = (y * width + x) * 4;

      // Calculate distance from center
      const dx = x - centerX;
      const dy = y - centerY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      // Normalize distance (0 at center, 1 at furthest corner)
      const normalizedDistance = distance / maxDistance;

      // Create smooth vignette falloff using a power curve
      // vignetteSize controls how much of the image is affected
      // Higher vignetteSize means the vignette starts closer to the center
      const vignetteRadius = 1 - vignetteSize; // Invert so higher size = larger clear area

      // Calculate vignette factor with smooth falloff
      let vignetteFactor;
      if (normalizedDistance <= vignetteRadius) {
        // Inside the clear area - no vignette
        vignetteFactor = 0;
      } else {
        // Outside clear area - apply smooth falloff
        const fadeDistance = normalizedDistance - vignetteRadius;
        const maxFadeDistance = 1 - vignetteRadius;
        const fadeRatio = fadeDistance / maxFadeDistance;

        // Use a smooth curve (quadratic) for more natural falloff
        vignetteFactor = Math.pow(fadeRatio, 1.5);
      }

      // Apply strength to the vignette factor
      const vignetteAmount = vignetteFactor * absStrength;

      // Apply the vignette effect
      if (isWhite) {
        // White vignette - brighten towards edges
        data[pixelIndex] = Math.min(
          255,
          data[pixelIndex] + (255 - data[pixelIndex]) * vignetteAmount
        );
        data[pixelIndex + 1] = Math.min(
          255,
          data[pixelIndex + 1] + (255 - data[pixelIndex + 1]) * vignetteAmount
        );
        data[pixelIndex + 2] = Math.min(
          255,
          data[pixelIndex + 2] + (255 - data[pixelIndex + 2]) * vignetteAmount
        );
      } else {
        // Black vignette - darken towards edges
        data[pixelIndex] = data[pixelIndex] * (1 - vignetteAmount);
        data[pixelIndex + 1] = data[pixelIndex + 1] * (1 - vignetteAmount);
        data[pixelIndex + 2] = data[pixelIndex + 2] * (1 - vignetteAmount);
      }
      // Alpha remains unchanged
    }
  }
};
